<template>
    <div class="row g-3">

        <div class="col-md-6 col-xl-4" v-for="(item, itemIndex) in list" :key="itemIndex">
            <!--begin::Card-->
            <router-link :to="item.slug ?? ''">
                <div class="card border border-2 border-gray-300 border-hover h-100">
                    <!--begin:: Card body-->
                    <div class="card-body">
                        <!--begin::Card Title-->
                        <div class="card-title d-flex align-items-center gap-3 m-0">
                            <!--begin::Avatar-->
                            <div class="card-list-icon-container" :class="item.class ?? 'bg-light'">
                                <span v-if="item.svgIcon || item.fontIcon" class="menu-icon">
                                    <span v-if="asideMenuIcons === 'svg'" class="svg-icon svg-icon-2">
                                        <inline-svg :src="item.svgIcon"/>
                                    </span>
                                </span>
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Name-->
                            <div class="fs-3 fw-bolder card-list-title" :class="item.class ?? ''">{{ item.name }}</div>
                            <!--end::Name-->
                        </div>
                        <!--end::Car Title-->
                        <!--begin::Description-->
                        <p class="text-gray-400 fw-bold fs-5 mt-4">{{ item.description }}</p>
                        <!--end::Description-->
                    </div>
                </div>
            </router-link>

            <!--end:: Card body-->
            <!--end::Card-->
        </div>

    </div>
</template>

<script>
import {asideMenuIcons} from "@/core/helpers/config";

export default {
    name: "card-list",
    props: {
        list: {type: Array},
    },
    data() {
        return {
            asideMenuIcons,
        }
    },
}
</script>